var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgCreditCard = _a => {
  var _b, _c;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5957 9.61702V6.57447C21.5957 5.92818 21.0718 5.40426 20.4255 5.40426H3.57447C2.92818 5.40426 2.40426 5.92818 2.40426 6.57447V9.61702H21.5957ZM21.5957 11.0213H2.40426V17.8085C2.40426 18.4548 2.92818 18.9787 3.57447 18.9787H20.4255C21.0718 18.9787 21.5957 18.4548 21.5957 17.8085V11.0213ZM3.57447 4H20.4255C21.8474 4 23 5.15263 23 6.57447V17.8085C23 19.2304 21.8474 20.383 20.4255 20.383H3.57447C2.15263 20.383 1 19.2304 1 17.8085V6.57447C1 5.15263 2.15263 4 3.57447 4Z",
    fill: (_c = props.color) !== null && _c !== void 0 ? _c : 'currentColor'
  }));
};
export default SvgCreditCard;